export const SNAP_HEIGHT = 30;
